import { useCallback, useMemo, useState } from "react";
import {
  nameToHslColor,
  nameToInitials,
} from "@circle-react-uikit/UserImage/name";
import classNames from "classnames";

interface MemberCardImageProps {
  className?: string;
  name: string;
  src: string;
}

export const MemberCardImage = ({
  src,
  name,
  className,
}: MemberCardImageProps) => {
  const hasImage = Boolean(src);
  const [hasError, setHasError] = useState(false);

  const handleOnError = useCallback(() => {
    setHasError(true);
  }, []);

  const initials = useMemo(() => nameToInitials(name), [name]);

  const style = useMemo(
    () => ({ backgroundColor: nameToHslColor(name) }),
    [name],
  );

  const shouldShowImage = hasImage && !hasError;

  return (
    <div
      className="relative isolate block size-full object-cover"
      data-testid="user-profile"
    >
      {shouldShowImage && (
        <img
          loading="lazy"
          className={classNames(
            "absolute left-0 top-0 z-10 size-full rounded-t-2xl object-cover",
            className,
          )}
          src={src}
          onError={handleOnError}
          alt={name}
        />
      )}
      <div
        className={classNames(
          "z-10 flex size-full items-center justify-center rounded-t-2xl text-xl font-medium tracking-normal text-white",
          {
            invisible: shouldShowImage,
          },
          className,
        )}
        style={style}
      >
        {initials}
      </div>
    </div>
  );
};
